export default "__VITE_ASSET__8R8ij7Lb__"